// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1HxAm","label":"SetPasswdForm_label__zputF"};